module.exports = __webpack_public_path__ + "img/e881fee.jpg";